export default __webpack_public_path__ + "./images/md.26d11aac.png";